import 'moment/locale/fr'
import { MEETINGS_NETWORK_TEST_SET, FORCE_CONSULTATIONS_PAGE_TAB } from './types'

/**
 * @description force conslutations page timeline type : pending OR started
 * @param {Object} tabs { pending: true/false, started: true/false }
 */
export const forceConsultationsPageTab = (tabs: any) => (dispatch: any) => {
    dispatch({
        type: FORCE_CONSULTATIONS_PAGE_TAB,
        payload: tabs,
    })
}

/**
 * should required run a network test
 * @param {boolean} shouldRunNetworkTest
 */
export const setShouldRunNetworkTest = (shouldRunNetworkTest: any) => (dispatch: any) => {
    dispatch({
        type: MEETINGS_NETWORK_TEST_SET,
        payload: shouldRunNetworkTest,
    })
}
